<template>
  <div id="app">
    <DropZone/>
  </div>
</template>

<script>
import DropZone from './components/DropZone'

export default {
  name: 'App',
  components: {
    DropZone
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue